import React from 'react'
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';

function Tile(props) {
    let { active, name, toggleTag } = props;
  return (
    <div className="tile" onClick={() => toggleTag(name)}>
      <div>
        {name} &nbsp;
        {active ? (
          <AiFillEye className="inline" size={27} />
        ) : (
          <AiFillEyeInvisible className="inline" size={27} />
        )}
      </div>
    </div>
  );
}

export default Tile